import { render, staticRenderFns } from "./CallMe.vue?vue&type=template&id=ecbf4a0e&scoped=true&"
import script from "./CallMe.vue?vue&type=script&lang=js&"
export * from "./CallMe.vue?vue&type=script&lang=js&"
import style0 from "./CallMe.vue?vue&type=style&index=0&id=ecbf4a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbf4a0e",
  null
  
)

export default component.exports